export default function assert(condition) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!condition) {
    throw new Error("JSON conversion error ".concat(message));
  }
}
//# sourceMappingURL=assert.js.map